import { render } from "./webhook.banner.vue?vue&type=template&id=4fa8d0bb"
import script from "./webhook.banner.vue?vue&type=script&lang=js"
export * from "./webhook.banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__